import {Course} from '@udemy-v2/browse-course';

export function useCourseIncludesRolePlay(course: Course) {
    const numRolePlays = course?.curriculum?.contentCounts?.rolePlaysCount ?? 0;
    return {numRolePlays, hasRolePlay: numRolePlays > 0};
}
